<script lang="ts" setup>
	defineProps<{
		cardDetails: DebitCardPayload | null
	}>()
	const { hasAnyPermission } = reactor(usePermissionStore())
</script>

<template>
	<div class="relative">
		<template v-if="!cardDetails?.type">
			<div class="flex h-full min-h-[inherit] items-start justify-between sm:flex-wrap lg:flex-nowrap">
				<div class="my-auto h-full gap-3">
					<div class="items-end xl:flex">
						<lazy-tools-icon icon="debit-card" dir="wallet" />
						<div class="py-5 xl:translate-y-3 xl:!py-0">
							<p class="max-w-xs text-xs font-medium leading-tight tracking-wide text-slate-600">
								You don't have a valid transaction card. Add a card to enable auto-renewal.
							</p>
						</div>
					</div>
				</div>

				<div class="mt-12 flex-none text-primary-2 md:mt-0">
					<button
						v-if="hasAnyPermission([PERMISSIONS.WALLET.ADD_CARD])"
						type="button"
						class="flex items-center gap-3 font-normal text-primary-2 transition hover:font-medium"
						@click="$emit('add-card')"
					>
						<span>Add New Card</span>

						<div
							class="hidden h-[40px] w-[40px] flex-none items-center justify-center rounded-md bg-primary-50 sm:flex"
						>
							<lazy-tools-icon icon="add-card" dir="wallet" />
						</div>
					</button>
				</div>
			</div>
		</template>

		<template v-else>
			<div class="mt-8 grid w-full justify-between gap-3 sm:flex md:mt-0">
				<wallet-debit-card :card-details="cardDetails" class="w-full max-w-[305px] border border-purple-100" />

				<div class="flex-none pt-3 text-primary-2 sm:pt-0">
					<nuxt-link
						v-if="hasAnyPermission([PERMISSIONS.CARD.EDIT, PERMISSIONS.CARD.REMOVE])"
						to="/manage-card"
						class="flex items-center gap-3 text-xs font-medium transition"
					>
						<span class="text-purple-500">Manage Card</span>

						<div
							class="hidden h-[40px] w-[40px] flex-none items-center justify-center rounded-md bg-purple-100 sm:flex"
						>
							<lazy-tools-icon
								icon="card-fill"
								path-class="fill-transparent stroke-purple-500"
								dir="wallet"
							/>
						</div>
					</nuxt-link>
				</div>
			</div>
		</template>
	</div>
</template>
